import {
  Shape5,
  Shape4,
  Shape3,
  Shape2,
  Shape8,
  Shape6,
  Shape7,
  Shape1,
  TopWave,
  BottomWave,
  BottomTallWave,
  BottomWave2,
  BottomTallWave2,
  BottomTallWave3,
  BottomWave5,
} from 'icons/authentication/shapes';
import React, { ReactNode } from 'react';

interface AuthenticationWrapperProps {
  children: ReactNode;
  styles?: React.CSSProperties;
  id?: string;
  className?: string;
}

const AuthenticationWrapper: React.FC<AuthenticationWrapperProps> = ({
  children,
  styles = {},
  id,
  className = '',
}) => {
  const wrapperStyles: React.CSSProperties = {
    ...styles,
    position: 'relative',
  };

  return (
    <div id={id} className={className} style={wrapperStyles}>
      <div
        id="scrollbarSmall"
        className="absolute top-0 z-10 left-0 bg-transparent w-full h-screen max-h-screen overflow-y-scroll"
      >
        {children}
      </div>
      <div className="absolute top-0 left-0 w-full h-screen max-h-screen overflow-y-hidden z-0">
        {/* <div className="absolute top-0 left-0">
          <Shape5 />
        </div> */}
        <div className="absolute top-0 right-0 w-1/2">
          <TopWave />
        </div>
        {/* <div className="absolute bottom-0 right-0">
          <Shape2 />
        </div> */}
        <div className="absolute bottom-0 left-0 w-1/2 z-10">
          <BottomWave />
        </div>
        {/* <div className="absolute bottom-0 left-0 w-full z-0">
          <BottomTallWave />
        </div> */}
        {/* <div className="absolute bottom-0 left-0 w-full z-0">
          <BottomTallWave2 />
        </div> */}
        {/* <div className="absolute bottom-0 left-0 w-full">
          <BottomWave2 />
        </div> */}
        {/* <div className="absolute bottom-0 left-0 w-full z-0">
          <BottomTallWave3 />
        </div> */}
        {/* <div className="absolute bottom-0 left-0 w-full z-0">
          <BottomWave5 />
        </div> */}
        {/* <div style={{ top: '15%', left: '20%', position: 'absolute' }}>
          <Shape1 />
        </div>
        <div style={{ top: '65%', left: '10%', position: 'absolute' }}>
          <Shape7 />
        </div>
        <div style={{ top: '25%', right: '10%', position: 'absolute' }}>
          <Shape6 />
        </div>
        <div style={{ top: '85%', right: '25%', position: 'absolute' }}>
          <Shape8 />
        </div> */}
      </div>
    </div>
  );
};

export default AuthenticationWrapper;
